<template>
  <div class="kyc-manage">
    <div class="c_top_title">{{ $t("bank_card.KYC_Management") }}</div>

    <div class="t_h1">
      <div class="t_h1_box">
        <el-form class="zdy_form" label-position="top">
          <el-form-item>
            <el-input
              v-model="email"
              :placeholder="$t('main.text185')"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-input
              v-model="username"
              :placeholder="$t('bank_card.Username')"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-select v-model="card_type" :placeholder="$t('main.text785')">
              <el-option
                v-for="item in categoryList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-select
              v-model="card_level"
              :placeholder="$t('bank_card.card_level')"
            >
              <el-option
                v-for="item in levelList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item>
            <el-input
              v-model="company_name"
              :placeholder="$t('main.text142')"
            ></el-input>
          </el-form-item> -->
          <el-form-item>
            <el-select v-model="occupation" :placeholder="$t('bank_card.Role')">
              <!-- 搜索 0默认所有 1股东 2员工 3URL -->
              <el-option :label="$t('main.text498')" value="1"></el-option>
              <el-option :label="$t('main.text794')" value="2"></el-option>
              <el-option :label="$t('bank_card.Staff')" value="3"></el-option>
              <el-option :label="$t('bank_card.URL')" value="4"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-select v-model="status" :placeholder="$t('main.text316')">
              <!-- // 1未提交；2审核中；3审核成功；4审核失败 -->
              <el-option :label="$t('str_status.str_status_1')" value="1" ></el-option>
              <el-option :label="$t('str_status.str_status_2')" value="2" ></el-option>
              <el-option :label="$t('new3_txt.P_Resubmission')" value="4" ></el-option>
              <el-option :label="$t('str_status.str_status_3')" value="3" ></el-option>
              <el-option :label="$t('new3_txt.KYC_Rejected')" value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="project_name == 'VisionLife'">
            <el-input
              v-model="visionLife_id"
              :placeholder="$t('bank_card.Client_Ref_ID')"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              :editable="false"
              popper-class="time_box"
              :clearable="false"
              v-model="time"
              type="daterange"
              :format="v_lan == 'en' ? 'dd/MM/yyyy' : 'yyyy/MM/dd'"
              value-format="yyyy-MM-dd"
              range-separator="-"
              :start-placeholder="$t('main.text324')"
              :end-placeholder="$t('main.text325')"
              @change="change_time"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item class="btn_box">
            <el-button
              class="reset_btn border_set_color"
              size="medium"
              @click="reset_btn"
              >{{ $t("main.text329") }}</el-button
            >
            <el-button class="apply_btn" size="medium" @click="apply_btn">{{
              $t("main.text330")
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="transaction_h">
      <div class="contract_m_top">
        <div class="c_top_title"></div>
      </div>

      <div class="t_h2">
        <div class="t_h2_box">
          <div>
            <div class="t_h2_txt1">
              {{ $t("bank_card.There") }} {{ total }}
              {{ $t("bank_card.are_records") }}
            </div>
          </div>
          <div>
            <el-button
              class="export_btn border_set_color2"
              size="medium"
              @click="download_btn"
            >
              {{ $t("main.text333") }}
            </el-button>
          </div>
        </div>
        <div class="t_h2_table zdy_tab_header cards_table">
          <el-table :data="tableData" stripe style="width: 100%">
            <el-table-column label="#" type="index" width="60">
            </el-table-column>

            <el-table-column :label="$t('main.text99')" min-width="110">
              <span slot-scope="props">
                <div>{{ overall_time(props.row.create_time) }}</div>
              </span>
            </el-table-column>

            <el-table-column :label="$t('main.text785')" min-width="110">
              <span slot-scope="props">
                <div>{{ props.row.card_type_name }}</div>
              </span>
            </el-table-column>

            <el-table-column
              :label="$t('bank_card.card_level')"
              min-width="110"
            >
              <span slot-scope="props">
                <div>{{ props.row.card_level_name }}</div>
              </span>
            </el-table-column>

            <el-table-column :label="$t('main.text185')" min-width="110">
              <span slot-scope="props">
                <div>{{ props.row.email }}</div>
              </span>
            </el-table-column>

            <el-table-column
              :label="$t('bank_card.kyc_id_status')"
              min-width="110"
            >
              <span slot-scope="props">
                <!-- 审核状态 0未提交；1审核中；2审核成功；3审核失败 -->
                <div v-if="props.row.kyc_id_status == 0">
                  {{ $t("str_status.str_status_1") }}
                </div>
                <div v-else-if="props.row.kyc_id_status == 1">
                  {{ $t("str_status.str_status_2") }}
                </div>
                <div v-else-if="props.row.kyc_id_status == 2">
                  {{ $t("str_status.str_status_3") }}
                </div>
                <div v-else-if="props.row.kyc_id_status == 3">
                  {{ $t('new3_txt.P_Resubmission') }}
                </div>
                <div v-else-if="props.row.kyc_id_status == 4">{{ $t('new3_txt.KYC_Rejected') }}</div>
                <div v-else>-</div>
              </span>
            </el-table-column>

            <el-table-column
              :label="$t('bank_card.kyc_address_status')"
              min-width="110"
            >
              <span slot-scope="props">
                <!-- 审核状态 0未提交；1审核中；2审核成功；3审核失败 -->
                <div v-if="props.row.kyc_address_status == 0">
                  {{ $t("str_status.str_status_1") }}
                </div>
                <div v-else-if="props.row.kyc_address_status == 1">
                  {{ $t("str_status.str_status_2") }}
                </div>
                <div v-else-if="props.row.kyc_address_status == 2">
                  {{ $t("str_status.str_status_3") }}
                </div>
                <div v-else-if="props.row.kyc_address_status == 3">
                  {{ $t('new3_txt.P_Resubmission') }}
                </div>
                <div v-else-if="props.row.kyc_address_status == 4">{{ $t('new3_txt.KYC_Rejected') }}</div>
                <div v-else>-</div>
              </span>
            </el-table-column>

            <el-table-column :label="$t('main.text519')" min-width="110">
              <span slot-scope="props">
                <div>{{ props.row.first_name }}</div>
              </span>
            </el-table-column>

            <el-table-column :label="$t('main.text520')" min-width="110">
              <span slot-scope="props">
                <div>{{ props.row.last_name }}</div>
              </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.Username')" min-width="110">
              <span slot-scope="props">
                <div>{{ props.row.username }}</div>
              </span>
            </el-table-column>

            <el-table-column
              :label="$t('bank_card.Client_Ref_ID')"
              min-width="110"
              v-if="project_name == 'VisionLife'"
            >
              <span slot-scope="props">
                <div>{{ props.row.visionLife_id }}</div>
              </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.Role')" min-width="110">
              <span slot-scope="props">
                <!-- 1Director 2Associates; 3Staff 4URL -->
                <div v-if="props.row.occupation == 1">
                  {{ $t("main.text498") }}
                </div>
                <div v-else-if="props.row.occupation == 2">
                  {{ $t("main.text794") }}
                </div>
                <div v-else-if="props.row.occupation == 3">
                  {{ $t("bank_card.Staff") }}
                </div>
                <div v-else-if="props.row.occupation == 4">
                  {{ $t("bank_card.URL") }}
                </div>
                <div v-else>-</div>
              </span>
            </el-table-column>

            <el-table-column :label="$t('main.text316')" min-width="110">
              <span slot-scope="props">
                <!-- // 1未提交；2审核中；3审核成功；4审核失败 -->
                <div v-if="props.row.status == 1">
                  {{ $t("str_status.str_status_1") }}
                </div>
                <div v-else-if="props.row.status == 2">
                  {{ $t("str_status.str_status_2") }}
                </div>
                <div v-else-if="props.row.status == 3">
                  {{ $t("str_status.str_status_3") }}
                </div>
                <div v-else-if="props.row.status == 4">
                  {{ $t('new3_txt.P_Resubmission') }}
                </div>
                <div v-else-if="props.row.status == 5">{{ $t('new3_txt.KYC_Rejected') }}</div>
                <div v-else>-</div>
              </span>
            </el-table-column>

            <el-table-column
              :label="$t('bank_card.KYC_Message')"
              min-width="110"
            >
              <span slot-scope="props">
                <!-- 1:数据问题; 2:状态问题; 3:用户kyc未通过; 4:分配卡失败; 5:激活失败; 6设置pin失败;加一下类型适配 -->
               
                <span v-if="!props.row.reject_reason"> - </span>
                <span
                  v-else
                  style="color: #409eff; cursor: pointer"
                  @click="ViewKYCMessage(props.row.reject_reason)"
                  >View</span
                >
              </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.Operator')" min-width="110">
              <span slot-scope="props">
                <div>{{ props.row.operator }}</div>
              </span>
            </el-table-column>

            <el-table-column :label="$t('main.text489')" min-width="110">
              <span slot-scope="props">
                <div v-if="props.row.check_des && props.row.check_status == 3">
                  <el-tooltip placement="top" popper-class="tooltip_w">
                    <i class="el-icon-question next_info"></i>
                    <div slot="content">
                      <div v-if="v_lan == 'ch'">
                        {{ JSON.parse(props.row.check_des).reason_ch }}
                      </div>
                      <div v-else-if="v_lan == 'jp'">
                        {{ JSON.parse(props.row.check_des).reason_jp }}
                      </div>
                      <div v-else>
                        {{ JSON.parse(props.row.check_des).reason_en }}
                      </div>
                    </div>
                  </el-tooltip>
                </div>
                <div v-else>-</div>
              </span>
            </el-table-column>

            <el-table-column
              :label="$t('bank_card.operating_time')"
              min-width="110"
            >
              <span slot-scope="props">
                <div v-if="props.row.process_time">
                  {{ overall_time(props.row.process_time) }}
                </div>
                <div v-else>-</div>
              </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.operation')" min-width="150">
              <span slot-scope="props">
                <div v-if="change_kyc_switch == 1">
                  <p
                    @click="submitTo(props.row)"
                    v-if="authjson.authjson(['12-2'])"
                    style="color: #409eff; cursor: pointer"
                  >
                    {{ $t("main.text36") }}
                  </p>
                </div>

                <!-- method: 提交方式 1网站内提交 2链接提交 -->
                <!-- check_status: 前台审核状态 1待审核 2审核通过 3审核失败 -->
                <div v-if="props.row.method == 2">
                  <div v-if="props.row.check_status == 1">
                    <div>{{ $t("main.text318") }}</div>
                   
                  </div>
                  <div v-else>
                    <span v-if="props.row.check_status == 2">{{
                      $t("main.text571")
                    }}</span>
                    <span v-else-if="props.row.check_status == 3">{{
                      $t("main.text572")
                    }}</span>
                  </div>
                </div>
                <div v-else>
                  <div>{{ $t("main.text585") }}</div>
                </div>
                
                <template
                  v-if="
                    props.row.method == 2 &&
                    [1, 3].includes(props.row.check_status)
                  "
                >
                  <div>
                    <el-button
                      v-if="authjson.authjson(['12-4'])"
                      @click="card_reason_ok_fun(props.row.id)"
                      class="tab_btn1"
                      icon="el-icon-check"
                      size="mini"
                    >
                      {{ $t("main.text583") }}
                    </el-button>
                  </div>
                </template>

                <template
                  v-if="
                    props.row.method == 2 &&
                    (props.row.check_status == 1 ||
                      (props.row.check_status === 2 &&
                        [2, 3].includes(props.row.op_status)))
                  "
                >
                  <div>
                    <el-button
                      v-if="authjson.authjson(['12-5'])"
                      @click="card_reason_no_fun(props.row.id)"
                      class="tab_btn2"
                      icon="el-icon-close"
                      size="mini"
                    >
                      {{ $t("main.text584") }}
                    </el-button>
                  </div>
                </template>
              </span>
            </el-table-column>
          </el-table>
          <!-- :page-sizes="[10, 20, 30, 40]" -->
          <el-pagination
            v-if="tableData.length > 0"
            background
            :page-sizes="[5, 10, 30, 40]"
            :page-size="limit"
            :current-page.sync="currentPage"
            layout="prev, pager, next"
            :total="total"
            @current-change="current_change"
          ></el-pagination>
        </div>
      </div>
    </div>

    <!-- 通过 弹框 -->
    <el-dialog
      :visible.sync="card_reason_ok_dlg"
      custom-class="log_out_dlg_bgc"
      append-to-body
      center
      :show-close="false"
      width="480px"
    >
      <div class="log_out1">
        <img
          style="width: 35px"
          src="../../assets/img/Pigeon_icon.png"
          alt=""
        />
      </div>
      <div class="log_out2 padding1">
        {{ $t("main.text590") }}
      </div>
      <div class="log_out3 padding2">
        {{ $t("main.text591") }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          class="confirm_btn2"
          @click="card_reason_ok_dlg = false"
          >{{ $t("main.text266") }}</el-button
        >
      </span>
    </el-dialog>

    <!-- 拒绝 弹框 -->
    <el-dialog
      :title="$t('main.text594')"
      :visible.sync="card_reason_no_dlg"
      custom-class="dlg element_input add_dlg"
      append-to-body
      width="480px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <el-form class="dlg_form dlg_form2" label-position="top">
            <div class="top_text">{{ $t("main.text595") }}</div>
            <el-form-item>
              <el-input
                type="textarea"
                v-model="card_reason"
                :placeholder="$t('main.text596')"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="card_reason_no_dlg = false"
          class="cancel_btn border_set_color2"
        >
          {{ $t("main.text7") }}
        </el-button>
        <el-button
          type="primary"
          @click="no_btn"
          class="confirm_btn confirm_btn_bgc"
        >
          {{ $t("main.text597") }}
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('bank_card.KYC_Message')"
      :visible.sync="ViewKYCMessageDlg"
      width="400px"
    >
      <div class="dialog_box">
        <p>
          {{ ViewKYCMessageVal }}
        </p>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import {
  accountKycList,
  card_audit,
  accountKycListDownload,
  getConfigData,
} from "@/api/api";

export default {
  data() {
    return {
      currentPage: 1,
      page: 1, //分页 从 1 开始
      limit: 10, //每页条数
      total: 0, //一共多少条
      tableData: [],
      time: "",
      company_name: "", //	公司名称
      card_name: "", // 卡名称
      // start_date: "", //	开始日期 2022-03-30
      // end_date: "", //	结束日期 2022-03-30
      email: "", //	申请信息填写的邮箱
      username: "", //	用户名
      card_level: "", //
      card_type: "",
      occupation: "", //	apply for 1Director 2Staff
      status: "", //	1待审核；2审核中；3审核成功；4审核失败
      visionLife_id: "",

      // change_kyc_switch:1/0,//修改kyc开关;1开;0关
      change_kyc_switch: sessionStorage.getItem("change_kyc_switch"),

      card_reason_ok_dlg: false,
      card_reason_no_dlg: false,
      card_reason: "",
      card_reason_no_id: "",
      ViewKYCMessageDlg: false,
      ViewKYCMessageVal: "",

      categoryList: [],
      levelList: [],
      company_type: sessionStorage.getItem("company_type"),
      project_name: sessionStorage.getItem("project_name"),
    };
  },
  beforeDestroy() {
    sessionStorage.removeItem("top_title_name");
  },
  mounted() {
    this.company_type = sessionStorage.getItem("company_type");
    sessionStorage.setItem("top_title_name", " ");
    this.project_name = sessionStorage.getItem("project_name");
    this.get_list();
    this.getContractConfig();
  },
  methods: {
    getContractConfig() {
      const that = this;
      getConfigData().then((res) => {
        if (res.data && res.data.code == 200) {
          that.categoryList = res.data.data.card_type;
          that.levelList = res.data.data.card_level;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    ViewKYCMessage(val) {
      this.ViewKYCMessageVal = val;
      this.ViewKYCMessageDlg = true;
    },
    change_time(v) {
      // console.log(v);
      v;
    },
    async get_list() {
      const res = await accountKycList({
        company_name: this.company_name,
        page: this.page,
        limit: this.limit,
        start_date: this.time[0] || "",
        end_date: this.time[1] || "",
        email: this.email,
        card_type: this.card_type,
        card_level: this.card_level,
        username: this.username,
        occupation: this.occupation,
        status: this.status,
        card_name: this.card_name,
        visionLife_id: this.visionLife_id,
      });
      if (res.data.code !== 200) {
        return this.message.ismessage("error", res.data.msg);
      }
      // console.log(res.data.data);
      this.total = res.data.data.count;
      this.tableData = res.data.data.list;
    },
    current_change(v) {
      this.page = v;
      this.limit = 10;
      this.get_list();
    },
    reset_btn() {
      this.limit = 10;
      this.currentPage = 1;
      this.company_name = ""; //	公司名称
      this.time = "";
      this.email = ""; //	申请信息填写的邮箱
      this.card_level = "";
      this.card_type = "";
      this.username = ""; //	用户名
      this.occupation = ""; //	apply for 1Director 2Staff
      this.status = ""; //
      this.visionLife_id = ""; //
      this.get_list();
    },
    apply_btn() {
      this.page = 1;
      this.limit = 10;
      this.currentPage = 1;
      this.get_list();
    },
    submitTo(row) {
      this.$router.push({
        path: "kyc_apply_card_input",
        query: { id: row.id, card_id: row.card_id, op_status: row.status },
      });
    },

    // 通过
    card_reason_ok_fun(id) {
      card_audit({
        id: id,
        status: 1,
      }).then((res) => {
        if (res.data.code == 200) {
          this.card_reason_ok_dlg = true;
          this.get_list();
        } else {
          this.message.ismessage("error", res.data.msg);
        }
      });
    },
    // 拒绝
    card_reason_no_fun(id) {
      this.card_reason = "";
      this.card_reason_no_dlg = true;
      this.card_reason_no_id = id;
      // console.log(id);
    },
    // 拒绝 弹框 确定按钮
    no_btn() {
      if (!this.card_reason) {
        return this.message.ismessage("error", this.$t("main.text598"));
      }
      let r_ch = "";
      let r_en = "";
      let r_jp = "";
      if (this.v_lan == "ch") {
        r_ch = this.card_reason;
        r_en = "";
        r_jp = "";
      } else if (this.v_lan == "jp") {
        r_ch = "";
        r_en = "";
        r_jp = this.card_reason;
      } else {
        r_ch = "";
        r_en = this.card_reason;
        r_jp = "";
      }

      card_audit({
        id: this.card_reason_no_id,
        status: 0,
        reason_ch: r_ch,
        reason_en: r_en,
        reason_jp: r_jp,
      }).then((res) => {
        if (res.data.code == 200) {
          this.message.ismessage("success", res.data.msg);
          this.card_reason_no_dlg = false;
          this.get_list();
        } else {
          this.message.ismessage("error", res.data.msg);
        }
      });
    },
    download_btn() {
      if (this.total <= 0) {
        return this.message.ismessage("error", this.$t("main.text335"));
      }
      accountKycListDownload({
        company_name: this.company_name,
        start_date: this.time[0] || "",
        end_date: this.time[1] || "",
        email: this.email,
        card_level: this.card_level,
        card_type: this.card_type,
        username: this.username,
        occupation: this.occupation,
        status: this.status,
        visionLife_id: this.visionLife_id,
      }).then((res) => {
        const filename =
          res.headers["content-disposition"].split(";")[1].split("=")[1] ||
          "download.xlsx";
        const link = document.createElement("a");
        const blob = new Blob([res.data], { type: "application/octet-stream" });
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `${filename}`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
  },
};
</script>
  
<style scoped>
.t_h1_top {
  margin-top: 40px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 16px;
}

.t_h1_box {
  background: #314b69;
  border-radius: 16px;
  box-sizing: border-box;
  padding: 28px;
  padding-bottom: 6px;
}

.zdy_form >>> .el-form-item {
  display: inline-block;
  width: 252px;
  margin-right: 20px;
}

.zdy_form >>> .el-date-editor.el-input,
.zdy_form >>> .el-select {
  width: 100%;
}

.zdy_form >>> .el-form-item:last-child {
  margin-right: 0;
}

.zdy_form >>> .el-form-item__label {
  padding: 0;
  line-height: inherit;
  margin-bottom: 8px;
  color: rgba(255, 255, 255, 0.6);
}

.zdy_form >>> .el-input__inner {
  background: #223c58;
  border: none;
  border-radius: 8px;
  color: #fff;
  width: 100%;
}

.reset_btn,
.reset_btn:hover,
.reset_btn:active,
.reset_btn:focus {
  color: #deb981;
  border-color: #deb981;
  background: transparent;
  min-width: 120px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  border-radius: 4px;
}

.apply_btn,
.apply_btn:hover,
.apply_btn:active,
.apply_btn:focus {
  min-width: 120px;
  border-color: #f1c788;
  background: linear-gradient(90deg, #f1c788 0.42%, #e3a84e 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-radius: 4px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  color: #04182a;
  margin-left: 20px;
}

.zdy_form .btn_box {
  width: auto;
}

.t_h2_box {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  align-items: center;
}

.t_h2_txt1 {
  font-style: normal;
  font-size: 14px;
  line-height: 26px;
}

.t_h2_txt2 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.8);
}

.export_btn,
.export_btn:hover,
.export_btn:active,
.export_btn:focus {
  color: #deb981;
  border-color: #deb981;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  /* min-width: 120px; */
  background: transparent;
}

.icon_width {
  width: 20px;
  vertical-align: middle;
  cursor: pointer;
}

.color_red {
  color: #f35f65;
}

.zdy_tab_header >>> .el-table tr th:last-child,
.zdy_tab_header >>> .el-table__body tr td:last-child {
  padding-left: 0 !important;
}

.btn_icon {
  width: 19px;
  vertical-align: middle;
  margin-right: 12px;
}

.tab_btn1 {
  height: 32px;
  border: 1px solid #deb981;
  border-radius: 4px;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #deb981;
  background: transparent;
  margin-top: 5px;
}

.tab_btn2 {
  height: 32px;
  border: 1px solid #ff4646;
  border-radius: 4px;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #ff4646;
  background: transparent;
  margin-top: 10px;
}

.top_text {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
  margin-bottom: 20px;
  word-break: break-word;
}

.dlg_form >>> .el-textarea__inner {
  background: #223c58;
  border-color: #223c58;
  color: #fff;
  height: 100px;
}

.confirm_btn_bgc,
.confirm_btn_bgc:hover,
.confirm_btn_bgc:focus,
.confirm_btn_bgc:active {
  background: #f35f65;
  border-color: #f35f65;
  color: #fff;
}

/* ---08-16 新增 --- */
.top_text2 {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  color: #ffffff;
  margin-bottom: 10px;
  word-break: break-word;
}

.info_1 {
  display: flex;
  border-bottom: 1px solid #314b69;
  box-sizing: border-box;
  padding: 20px 0;
}

.info_1_left {
  width: 60%;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
}

.info_1_right {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  opacity: 0.6;
}

.top_text3 {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  opacity: 0.6;
}

.amount_box {
  box-sizing: border-box;
  padding: 20px 0;
  border-bottom: 1px solid #223c58;
}

.top_text4 {
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  margin-bottom: 8px;
}

.top_text5 {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  opacity: 0.6;
}

.top_text5_2:nth-child(8) {
  padding-top: 10px;
}

.top_text5_2 {
  padding-top: 2px;
}

/* -- 输入下拉 选择币种 */
.zdy_input >>> .el-input__inner {
  /* width: 224px; */
  height: 68px;
  background: #223c58;
  border: 1.5px solid rgba(49, 72, 105, 0.1);
  border-radius: 8px 0px 0px 8px;
  display: inline-block;
  font-size: 24px;
  color: #fff;
}

.zdy_input >>> .el-input {
  width: 100%;
}

.zdy_input {
  display: flex;
}

.zdy_form >>> .el-form-item__label {
  line-height: inherit;
  padding: 0;
  padding-bottom: 8px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #fff;
}

.type_box {
  /* width: 154px; */
  width: 170px;
  height: 68px;
  border-radius: 8px 0 0 8px;
  cursor: pointer;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: #041728;
}

.type_box1 {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.type_box1 img {
  width: 26px;
  vertical-align: middle;
  margin-right: 8px;
}

.type_box2 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
}

.type_box3 {
  color: rgba(255, 255, 255, 0.8);
}

.bz_list {
  box-sizing: border-box;
  padding: 8px;
}

.bz_list1 {
  margin-bottom: 10px;
}

.bz_list .bz_list1:last-child {
  margin-bottom: 0;
}

.inp_btm_tit {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 12px;
}

/* ----over---- */
.box_margin {
  box-sizing: border-box;
  padding: 8px 0 12px;
}

.top_text6 {
  margin-top: 25px;
  margin-bottom: 8px;
}

.top_text7 {
  /* padding: 18px 12px 20px;
    background: #041728; */
  border-radius: 8px;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  color: #ffffff;
  display: flex;
  align-items: center;
}

.div_num {
  flex: 1;
  background: #223c58;
  text-align: right;
  height: 68px;
  line-height: 68px;
  box-sizing: border-box;
  padding-right: 15px;
  border-radius: 0 8px 8px 0;
}

.top_text7_2 {
  padding: 18px 12px 20px;
  background: #041728;
  border-radius: 0 8px 8px 0;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  color: #ffffff;
  min-width: 120px;
  text-align: center;
}

.top_text8 {
  display: flex;
  margin-top: 12px;
}

.top_text8 > div {
  width: 50%;
}

.top_text9 {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #ffffff;
  opacity: 0.6;
}

.top_text10 {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #ffffff;
}

.warning_red {
  background: #fedfe0;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 12px 15px;
  display: flex;
  align-items: center;
  margin-top: 8px;
}

.warning_yellow {
  background: #e8dac8;
}

.warning_red_icon i {
  color: #f35f65;
  font-size: 25px;
  margin-right: 12px;
}

.warning_red_text {
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  color: #f35f65;
}

.warning_yellow_icon i,
.warning_yellow_text {
  color: #b28247;
}

.top_up_link {
  color: #041728;
  text-decoration: underline;
}

.yellow {
  color: #d9b680;
  cursor: pointer;
  margin-right: 10px;
}
</style>
  
<style>
.cards_table .row_2_bgc,
.cards_table .row_2_bgc .el-table__cell {
  background: #172c43 !important;
}

.cards_table .row_2_bgc:hover {
  background: #172c43 !important;
}

.cards_table .el-table--striped .el-table__body .row_2_bgc,
.cards_table .el-table--striped .el-table__body .row_2_bgc td.el-table__cell {
  background: #172c43 !important;
}

/* ------ */
.bz_pop {
  color: #fff;
  font-size: 15px;
  background: #041e35;
  box-shadow: 0px 0px 4px #4f78a9;
  /* border-radius: 16px; */
  border: none;
  box-sizing: border-box;
  transform: translateY(-10px);
}

.bz_pop .popper__arrow {
  display: none;
}

.btm_text {
  line-height: initial;
  padding-top: 5px;
}

.show-pwd {
  position: absolute;
  right: 10px;
  top: 1px;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
}

.show-pwd img {
  width: 18px;
}

.c_top_title {
  font-size: 16px;
  margin-bottom: 20px;
}

.num_item {
  box-sizing: border-box;
  padding: 20px 30px;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #314b69;
}

.num_item div {
  margin-bottom: 7px;
}

.num_item div:last-child {
  margin-bottom: 0;
}

.c_top_num_box .num_item {
  margin-right: 20px;
}

.c_top_num_box .num_item:last-child {
  margin-right: 0;
}

.el-input.is-disabled .el-input__inner {
  color: #000;
}

.bing_btn {
  cursor: pointer;
}

.select_btn {
  cursor: pointer;
  color: #11b8a6;
}

.binding_btn {
  cursor: pointer;
  color: #a2ef4d;
}

.next_info {
  cursor: pointer;
  color: #f1c788;
}

.card_body {
  max-height: 80vh;
  overflow-y: auto;
}

.icon_question {
  margin-left: 5px;
  cursor: pointer;
}

.block_value_box {
  text-align: center;
  margin-top: 30px;
}

.block_value_box .el-select .el-input__inner {
  background: #223c58;
  border: none;
  /* border-radius: 8px; */
  color: #fff;
}

.card_foot {
  padding-bottom: 20px;
}
</style>
  
<style>
.binding_dlg .d_body {
  max-width: 95% !important;
  margin: auto !important;
  padding-top: 0 !important;
}

/* @media screen and (max-height: 757px) {
    .card_dlg_position{
      top: 0 !important;
      transform: translate(-50%, 0) !important;
    }
  } */
.card_foot .el-dialog__footer {
  padding-bottom: 30px;
}
</style>
  
<style scoped>
@media screen and (max-width: 850px) {
  .t_h2_box {
    display: block;
    margin-top: 0;
    align-items: left;
  }

  .t_h1_top {
    margin-top: 0;
  }

  .t_h2_txt1 {
    margin-bottom: 10px;
    margin-top: 40px;
  }

  .num_item {
    width: 100%;
    margin-right: 0;
    margin-bottom: 15px;
  }
}
</style>
<style lang="less">
.kyc-manage {
  .el-dialog {
    background: #071f34;
    color: white;

    .el-dialog__title {
      margin-left: 0px;
      color: white;
    }

    .el-dialog__headerbtn {
      left: auto;
      font-size: 16px !important;
    }
  }
}
</style>